import React, { useEffect } from 'react';
import { sendLiveRegionMessage } from '../../../../atoms/LiveRegionGlobal/LiveRegionGlobal';
import { StatusInfoError } from '../../../../../_lib/components/StatusInfo';

type ContentWrapperInteractionStatusType = {
  message: string;
};

/**
 * Shows the current status of interaction inside the ContentWrapper
 */
export default function ContentWrapperInteractionStatus({ message }: ContentWrapperInteractionStatusType) {
  useEffect(() => {
    sendLiveRegionMessage(message);
  }, [message]);

  return <StatusInfoError message={message} />;
}
